import React, { useEffect, useState } from "react";
import { Clock4, CalendarCheck, Trash2, ChevronsUpDown } from "lucide-react";
import { can_visit, exchangeDate } from "../../helpers";
import Badge from "../UI/Badge";
import DeleteModal from "../Modal/DeleteModal";
import AppointmentConfirmationModal from "../Modal/AppointmentConfirmationModal";
import AppointmentCancellationModal from "../Modal/AppointmentCancellationModal";
import Skeleton from "react-loading-skeleton";

const styles = {
  display: "flex",
  alignItems: "center",
  gap: "5px",
  cursor: "pointer",
};

export default function AppointmentsDataTable(props) {
  const {
    tableData = [],
    handleCheckboxChange = () => {},
    handleSelectAll = () => {},
    selectAll = false,
    handleAppointmentConfirmation = () => {},
    handleAppointmentCancellation = () => {},
    handleAppointmentCompleted = () => {},
    handleDeleteRecord = () => {},
    reloadData = () => {},
    reloadDataFilter = {},
    account_id,
    location_id,
    dataLoading,
    setDataLoading = () => {},
    handleAppointmentViewModal = () => {},
    previousScrollPosition = 0,
    setPreviousScrollPosition = () => {},
    smsLimit = 0,
  } = props;

  const [orderBy, setOrderBy] = useState();
  const [activeModal, setActiveModal] = useState(false);
  const [cancelModal, setCancelModal] = useState(false);
  const [selectedAppointment, setSelectedAppointment] = useState({});
  const [viewStatusOptions, setViewStatusOptions] = useState({});
  const [deleteRecord, setDeleteRecord] = useState({});
  const [activeDeleteModal, setActiveDeleteModal] = useState(false);

  const handleCloseDialog = () => {
    setActiveModal(false);
    setCancelModal(false);
    setSelectedAppointment({});
    window.scrollTo(0, previousScrollPosition);
  };

  const handleSelectOption = (option, item) => {
    if (option === "confirm") {
      setActiveModal(true);
      setPreviousScrollPosition(window.scrollY);
      window.scrollTo(0, 0);
    }
    if (option === "completed") {
      handleAppointmentCompleted(item.hex_id, item.appointment_time, item.hex_id);
    }
    if (option === "cancel") {
      setCancelModal(true);
      setPreviousScrollPosition(window.scrollY);
      window.scrollTo(0, 0);
    }
  };

  const handleOrderChange = (name, type = "asc") => {
    name = name.toString();
    setOrderBy(name);
    if (reloadDataFilter.order_by && reloadDataFilter.order_by[0] == name) {
      if (reloadDataFilter.order_by[1] == "asc") {
        type = "desc";
      }
    }
    const orderFilter = { order_by: [name, type.toString()] };
    const filter_merge = { ...reloadDataFilter, ...orderFilter };
    reloadData(filter_merge);
    setDataLoading(true);
  };

  const handleOutsideClick = (event) => {
    if (!event.target.closest(".dropdown-container")) {
      setViewStatusOptions({});
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  const handleDropdownClick = (index) => {
    setViewStatusOptions((prev) => {
      const newViewStatusOptions = {};
      newViewStatusOptions[index] = !prev[index];
      return newViewStatusOptions;
    });
  };

  return (
    <>
      {/* {selectAll && (
        <>
          <hr />
          <div className="docpro_data_table_btns">
            <button className="docpro_bordered_btn docpro_fw_600 docpro_red_color">
              <Trash2 width={20} height={20} />
              Delete
            </button>
          </div>
        </>
      )} */}
      <div className="docpro_table_responsive" style={{ minHeight: "250px" }}>
        <table className="docpro_mb_0">
          <thead>
            <tr>
              <th style={{ width: "45px" }}>
                <div className="docpro_checkbox" style={{ top: "3px" }}>
                  <input
                    type="checkbox"
                    checked={tableData.length > 0 && selectAll}
                    onChange={handleSelectAll}
                    disabled={tableData.length === 0}
                  />
                  <label></label>
                </div>
              </th>
              {can_visit("_role_enterprise") && (
                <>
                  {/* <th 
                    onClick={() => {
                      handleOrderChange("account_name");
                    }}
                    className={orderBy === "account_name" ? "docpro_accent_color" : ""}
                  >
                    <div style={styles}>
                      Practice Name <ChevronsUpDown size={"12"} />
                    </div>
                  </th> */}
                  <th> Practice Name </th>
                  <th>
                    <div
                      onClick={() => {
                        handleOrderChange("location_id");
                      }}
                      className={
                        orderBy === "location_id" ? "docpro_accent_color" : ""
                      }
                    >
                      <div style={styles}>
                        Location <ChevronsUpDown size={"12"} />
                      </div>
                    </div>
                  </th>
                </>
              )}
              <th>
                <div
                  onClick={() => {
                    handleOrderChange("last_name");
                  }}
                  className={
                    orderBy === "last_name" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>
                    Name <ChevronsUpDown size={"12"} />
                  </div>
                </div>
              </th>
              <th>
                <div
                  onClick={() => {
                    handleOrderChange("phone");
                  }}
                  className={
                    orderBy === "phone" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>
                    Phone <ChevronsUpDown size={"12"} />
                  </div>
                </div>
              </th>
              <th>
                <div
                  onClick={() => {
                    handleOrderChange("date_of_birth");
                  }}
                  className={
                    orderBy === "date_of_birth" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>
                    DOB <ChevronsUpDown size={"12"} />
                  </div>
                </div>
             </th>
              <th>
                <div
                  onClick={() => {
                    handleOrderChange("insurance");
                  }}
                  className={
                    orderBy === "insurance" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>
                    Insurance Name <ChevronsUpDown size={"12"} />
                  </div>
                </div>
             </th>
              <th>
                <div
                  onClick={() => {
                    handleOrderChange("insurance_id");
                  }}
                  className={
                    orderBy === "insurance_id" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>
                    Insurance ID <ChevronsUpDown size={"12"} />
                  </div>
                </div>
             </th>
              <th>
                <div
                  onClick={() => {
                    handleOrderChange("appointment_date");
                  }}
                  className={
                    orderBy === "appointment_date" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>
                    Appointment <ChevronsUpDown size={"12"} />
                  </div>
                </div>
              </th>
              {/* <th>Specialty</th> */}
              <th>
                <div
                  onClick={() => {
                    handleOrderChange("status");
                  }}
                  className={
                    orderBy === "status" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>
                    Status <ChevronsUpDown size={"12"} />
                  </div>
                </div>
              </th>
              <th className="docpro_text_center">Action</th>
            </tr>
          </thead>
          <tbody>
            {!dataLoading ? (
              tableData.length > 0 ? (
                tableData?.map((item, index) => (
                  <tr key={index}>
                    <td style={{ width: "45px" }}>
                      <div className="docpro_checkbox" style={{ top: "3px" }}>
                        <input
                          type="checkbox"
                          checked={item.checked || false}
                          onChange={() => handleCheckboxChange(item.id)}
                        />
                        <label></label>
                      </div>
                    </td>
                    {can_visit("_role_enterprise") && (
                      <>
                        <td className="pointer" onClick={() => handleAppointmentViewModal(item)}> {item.accountName} </td>
                        <td className="pointer" onClick={() => handleAppointmentViewModal(item)}>{item?.location ? item.location?.name : ""}</td>
                      </>
                    )}
                    <td className="pointer" onClick={() => handleAppointmentViewModal(item)}>{`${item.lastName} ${item.firstName}`}</td>
                    <td className="pointer" onClick={() => handleAppointmentViewModal(item)}>{item.phoneNumber}</td>
                    <td className="pointer" onClick={() => handleAppointmentViewModal(item)}>{exchangeDate(item.dob)}</td>
                    <td className="pointer" onClick={() => handleAppointmentViewModal(item)}>{item.insuranceName}</td>
                    <td className="pointer" onClick={() => handleAppointmentViewModal(item)}>{item.insuranceId}</td>
                    <td className="pointer" onClick={() => handleAppointmentViewModal(item)}>
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "6px",
                        }}
                      >
                        <Clock4
                          style={{ color: "#7E808A" }}
                          width={16}
                          height={16}
                        />{" "}
                        {exchangeDate(item.appointmentDate)}
                      </span>
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "6px",
                          marginLeft: "8px",
                        }}
                      >
                        <Clock4
                          width={16}
                          height={16}
                          style={{ color: "#7E808A" }}
                        />{" "}
                        {item?.appointmentTime || ""}
                      </span>
                    </td>
                    {/* <td className="pointer" onClick={() => handleAppointmentViewModal(item)}>{item.specialty}</td> */}
                    <td className="pointer" onClick={() => handleAppointmentViewModal(item)}>
                      {item.status === "expired" && (
                        <Badge color="orange">Expired</Badge>
                      )}
                      {item.status === "cancelled" && (
                        <Badge color="red">Cancelled</Badge>
                      )}
                      {item.status === "confirmed" && (
                        <Badge color="cyan">Confirmed</Badge>
                      )}
                      {item.status === "rescheduled" && (
                        <Badge color="purple">Rescheduled</Badge>
                      )}
                      {item.status === "pending" && (
                        <Badge color="olive">Pending</Badge>
                      )}
                      {item.status === "completed" && (
                        <Badge color="green">Completed</Badge>
                      )}
                    </td>

                    <td className="docpro_text_center">
                      {item.status !== "completed" && (
                        <>
                          <div className="docpro_icon_btns">
                            {can_visit("appointment_status") && (
                              <div className="dropdown-container relative">
                                <button className="docpro_icon_btn last_btn_tip" onClick={() => handleDropdownClick(index)}>
                                  <CalendarCheck width={18} height={18} />
                                  <span className="docpro_tip">Update Appointment</span>
                                </button>
                                {viewStatusOptions[index] && (
                                  <div className={`docpro_button_toggle_options ${index > 4 && 'top_position'}`}>
                                    {(can_visit("appointment_status") && can_visit("appointment_status_confirm")) && (
                                      <p onClick={() => {setSelectedAppointment(item); handleSelectOption('confirm', item);}}>Confirm</p>
                                    )}
                                    {(can_visit("appointment_status") && can_visit("appointment_status_completed")) && (
                                      <p onClick={() => {setSelectedAppointment(item); handleSelectOption('completed', item);}}>Completed</p>
                                    )}
                                    {(can_visit("appointment_status") && can_visit("appointment_status_cancel")) && (
                                      <p onClick={() => {setSelectedAppointment(item); handleSelectOption('cancel', item);}}>Cancel</p>
                                    )}
                                  </div>
                                )}
                              </div>
                            )}
                            {can_visit("appointment_delete") && (
                              <button
                                type="button"
                                className="docpro_icon_btn docpro_icon_btn_red last_btn_tip"
                                onClick={() => {
                                  setDeleteRecord(item);
                                  setActiveDeleteModal(true);
                                  setPreviousScrollPosition(window.scrollY);
                                  window.scrollTo(0, 0);
                                }}
                              >
                                <Trash2 width={18} height={18} />
                                <span className="docpro_tip">Delete</span>
                              </button>
                            )}
                          </div>
                        </>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="no_data docpro_p_0" style={{ height: "250px" }} colSpan={`${can_visit("_role_enterprise") ? 11 : 9}`}>
                    No data available
                  </td>
                </tr>
              )
            ) : (
              Array.from({ length: 8 }).map((_, index) => (
                <tr key={index} style={{ height: '50px' }}>
                  <td style={{ width: "45px" }}> <Skeleton width="1.2rem" borderRadius="8px"></Skeleton> </td>
                  {can_visit("_role_enterprise") && (
                    <>
                      <td> <Skeleton width={`${3 + (index % 2)}rem`} borderRadius="8px"></Skeleton> </td>
                      <td> <Skeleton width={`${4 + (index % 1.2)}rem`} borderRadius="8px"></Skeleton> </td>
                    </>
                  )}
                  <td> <Skeleton width={`${5 + (index % 2.5)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width="6rem" borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width="5rem" borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${5.2 + (index % 3.5)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width="4rem" borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${5 + (index % 1.5)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${3 + (index % 1.8)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td className="text-center"> <Skeleton width="3rem" borderRadius="8px"></Skeleton> </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      {activeModal && (
        <AppointmentConfirmationModal
          handleAppointmentConfirmation={handleAppointmentConfirmation}
          selectedAppointment={selectedAppointment}
          onClose={handleCloseDialog}
          account_id={account_id}
          location_id={location_id}
          activeModal={activeModal}
          smsLimit={smsLimit}
        />
      )}

      {activeDeleteModal && (
        <DeleteModal
          handleDelete={() => handleDeleteRecord(deleteRecord?.hex_id)}
          name="this appointment"
          activeModal={activeDeleteModal}
          setActiveModal={setActiveDeleteModal}
          previousScrollPosition={previousScrollPosition}
          setPreviousScrollPosition={setPreviousScrollPosition}
        />
      )}

      {cancelModal && (
        <AppointmentCancellationModal
          account_id={account_id}
          location_id={location_id}
          handleAppointmentCancellation={handleAppointmentCancellation}
          selectedAppointment={selectedAppointment}
          onClose={handleCloseDialog}
          cancelModal={cancelModal}
          smsLimit={smsLimit}
        />
      )}
    </>
  );
}
